import { RegistriaUserErrorResponse } from './registria-user-error-response.interface';
import { RegistriaUserResponse } from './registria-user-response.interface';

export interface RegistriaUsersResponse
  extends RegistriaUserResponse,
    RegistriaUserErrorResponse {
  sessionId: string;
}
